/* Canadian customs acknowledgement — behaviour.
 *
 * THIS LIVES IN AN ASSET, NOT INSIDE THE SNIPPET, AND THAT IS THE WHOLE POINT.
 * The cart drawer injects its HTML with innerHTML, and a <script> that arrives
 * that way NEVER executes. Inline, the guard worked on /cart (server-rendered)
 * and silently did nothing on every other page: the checkbox was there, looked
 * right, and let anyone through. Loaded from the layout it runs once per page,
 * and its listeners are delegated on document, so they cover DOM that appears
 * later.
 */
(function () {
  if (window.__mardoCaAck) return;
  window.__mardoCaAck = true;

  // The version travels with the acceptance: if the wording ever changes, an
  // old order still says which text that buyer agreed to.
  var VERSION = 'v1';
  var KEY = 'mardo_ca_ack';

  function read() { try { return window.localStorage.getItem(KEY); } catch (e) { return null; } }
  function write(v) {
    try { v === null ? window.localStorage.removeItem(KEY) : window.localStorage.setItem(KEY, v); } catch (e) {}
  }
  function accepted() { return read() === VERSION; }
  function blocks() { return document.querySelectorAll('[data-mardo-ca-ack]'); }

  // Whether the shopper themselves picked a country other than Canada in the
  // estimator. Only their own action counts: the select is BORN holding the
  // market's country ("United States" for most visitors), and reading that
  // default as a statement would silently switch the whole guard off.
  var statedNonCanada = false;

  function estimatorSaysCanada() {
    var found = false;
    document.querySelectorAll('select[name="country"]').forEach(function (sel) {
      var v = (sel.value || '').trim().toLowerCase();
      if (v === 'canada' || v === 'ca') found = true;
    });
    return found;
  }

  // Required only when the destination is KNOWN to be Canada, in this order:
  //   1. the estimator says Canada — the most direct statement there is;
  //   2. the shopper picked another country themselves, so an inference must
  //      not override them into ticking a Canadian disclaimer;
  //   3. otherwise fall back to the market they are browsing or the address on
  //      their account.
  // Anywhere else this stays an offer, never a gate: a US buyer is not stopped.
  function required(el) {
    if (estimatorSaysCanada()) return true;
    if (statedNonCanada) return false;
    return el.getAttribute('data-detected') === 'true';
  }

  // The cart page and the drawer each mount a copy, so ticking it in one is
  // honoured by the other.
  function sync() {
    blocks().forEach(function (el) {
      var box = el.querySelector('[data-mardo-ca-accept]');
      if (box) box.checked = accepted();
      if (accepted()) {
        el.classList.remove('is-blocked');
        var err = el.querySelector('[data-mardo-ca-error]');
        if (err) err.hidden = true;
      }
    });
  }

  // Saved onto the cart so it lands on the order: this is the record that
  // matters when a customer disputes a seizure.
  function saveToCart() {
    var value = accepted() ? 'Accepted ' + VERSION + ' — ' + new Date().toISOString() : null;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { 'Canada Customs Disclaimer': value } })
    }).catch(function () {});
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('[data-mardo-ca-accept]')) {
      write(t.checked ? VERSION : null);
      sync();
      saveToCart();
    } else if (t.matches('select[name="country"]')) {
      // A change here is the shopper speaking, so it now outranks geolocation.
      statedNonCanada = !estimatorSaysCanada();
      // Picking a different country clears a stale "you must accept" state.
      blocks().forEach(function (el) {
        el.classList.remove('is-blocked');
        var err = el.querySelector('[data-mardo-ca-error]');
        if (err) err.hidden = true;
      });
    }
  });

  document.addEventListener('click', function (e) {
    var toggle = e.target && e.target.closest ? e.target.closest('[data-mardo-ca-toggle]') : null;
    if (!toggle) return;
    e.preventDefault();
    var full = toggle.closest('[data-mardo-ca-ack]').querySelector('[data-mardo-ca-full]');
    if (full) {
      full.hidden = !full.hidden;
      toggle.textContent = full.hidden ? 'Read the full terms' : 'Hide the full terms';
    }
  });

  // The theme asks every listener to vote before it opens checkout.
  document.addEventListener('eurus:cart:validate', function (e) {
    if (!e.detail || !e.detail.isCheckOut) return;
    var blocked = false;
    blocks().forEach(function (el) {
      if (!required(el) || accepted()) return;
      blocked = true;
      el.classList.add('is-blocked');
      var err = el.querySelector('[data-mardo-ca-error]');
      if (err) err.hidden = false;
      if (el.offsetParent !== null) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    if (blocked && window.Alpine && Alpine.store && Alpine.store('xCartHelper')) {
      Alpine.store('xCartHelper').validated = false;
    }
  });

  document.addEventListener('DOMContentLoaded', sync);
  // The drawer injects its HTML after the fact; re-sync when the cart changes.
  ['eurus:cart-drawer:open', 'eurus:cart:update', 'shopify:section:load'].forEach(function (evt) {
    document.addEventListener(evt, function () { setTimeout(sync, 50); });
  });
  sync();
})();
